/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Issue_BtnInputs */



/**
* | output |
* | --- |
* | "Issue Sanction" |
*
* @param {Sanction_Mgr_Issue_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_issue_btn = /** @type {((inputs?: Sanction_Mgr_Issue_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Issue_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Émettre une sanction")
	if (locale === "es") return /** @type {LocalizedString} */ ("Emitir sanción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Emitir Sanção")
	if (locale === "it") return /** @type {LocalizedString} */ ("Emetti Sanzione")
	return /** @type {LocalizedString} */ ("Issue Sanction")
});